import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Typography, Tabs, Tab, Paper } from '@mui/material'
import { TabPanel } from '@components/atoms'
import AutoQA from '@features/qa/autoQA'
import ManualQAConfig from '@features/qa/manualQAConfig'

import SettingsQAConfig from '../SettingsQAConfig'
import SettingsImportQA from '../SettingsImportQA'
import styles from './SettingsQA.module.scss'

const SettingsQA = ({ userID, userOrganization }) => {
  const [tab, setTab] = useState(0)

  return (
    <div className={styles.root}>
      <div className={styles.pageHeader}>
        <Typography variant="h4" component="h1" className={styles.pageTitle}>
          Quality Assurance
        </Typography>
        <Typography variant="body2" className={styles.pageSubtitle}>
          Configure automated QA, evaluation criteria, manual forms, and import results
        </Typography>
      </div>

      <Paper className={styles.tabsPaper}>
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          className={styles.tabs}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Auto QA" id="qa-tab-0" aria-controls="qa-tabpanel-0" />
          <Tab label="QA Criteria" id="qa-tab-1" aria-controls="qa-tabpanel-1" />
          <Tab label="Manual QA Forms" id="qa-tab-2" aria-controls="qa-tabpanel-2" />
          <Tab label="Import QA" id="qa-tab-3" aria-controls="qa-tabpanel-3" />
        </Tabs>

        <TabPanel value={tab} index={0} idPrefix="qa">
          <AutoQA />
        </TabPanel>
        <TabPanel value={tab} index={1} idPrefix="qa">
          <SettingsQAConfig />
        </TabPanel>
        <TabPanel value={tab} index={2} idPrefix="qa">
          <ManualQAConfig />
        </TabPanel>
        <TabPanel value={tab} index={3} idPrefix="qa">
          <SettingsImportQA userID={userID} userOrganization={userOrganization} />
        </TabPanel>
      </Paper>
    </div>
  )
}

SettingsQA.propTypes = {
  userID: PropTypes.string,
  userOrganization: PropTypes.string,
}

export default SettingsQA
